import * as React from 'react';
import { Route } from 'react-router';

import AuthenticationApp from 'bundles/authentication/components/AuthenticationApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const SSOCallback = loadOnRoute(() => import('bundles/authentication/components/sso/SSOCallback'));
const CreatePasswordPage = loadOnRoute(
  () => import('bundles/authentication/components/reset-password/CreatePasswordPage')
);
const ResetPage = loadOnRoute(() => import('bundles/authentication/components/reset-password/ResetPage'));
const ResetConfirmPage = loadOnRoute(() => import('bundles/authentication/components/reset-password/ResetConfirmPage'));
const DecodeStandardMagicLinkPage = loadOnRoute(() =>
  import('bundles/authentication/components/magic-link/DecodeMagicLink').then(
    (module) => module.DecodeStandardMagicLinkPage
  )
);
const DecodeSsoSamlMagicLinkPage = loadOnRoute(() =>
  import('bundles/authentication/components/magic-link/DecodeMagicLink').then(
    (module) => module.DecodeSsoSamlMagicLinkPage
  )
);

const LogoutPage = loadOnRoute(() => import('bundles/authentication/components/logout/LogoutPage'));
const EmailVerificationPage = loadOnRoute(
  () => import('bundles/authentication/components/email-verification/EmailVerificationPage')
);
const OffBoardingEmailVerificationPage = loadOnRoute(
  () => import('bundles/authentication/enterprise/components/OffBoardingEmailVerificationPage')
);
const RecoveryEmailVerificationPage = loadOnRoute(
  () => import('bundles/authentication/enterprise/components/RecoveryEmailVerificationPage')
);

const StandaloneAuthPage = loadOnRoute(() => import('bundles/authentication/components/StandaloneAuthPage'));
const OpenAIAuthPage = loadOnRoute(() => import('bundles/authentication/components/openai/OpenaiAuthPage'));

export default (
  <Route path="/" component={AuthenticationApp}>
    <Route path="login" getComponent={StandaloneAuthPage} />
    <Route path="signup" getComponent={StandaloneAuthPage} />
    <Route path="reset" getComponent={ResetPage} />
    <Route path="reset/confirm/:token" getComponent={ResetConfirmPage} />
    <Route path="reset/create/:token" getComponent={ResetConfirmPage} />
    <Route path="magicLinks/:token" getComponent={DecodeStandardMagicLinkPage} />
    <Route path="ssoSamlMagicLinks/:token" getComponent={DecodeSsoSamlMagicLinkPage} />

    <Route path="ssoCallback" getComponent={SSOCallback} />
    <Route path="account/create-password/:token" getComponent={CreatePasswordPage} />
    <Route path="account/confirmation/create-password" getComponent={CreatePasswordPage} />
    <Route path="account/logout" getComponent={LogoutPage} />
    <Route path="account/email_verify/:token" getComponent={EmailVerificationPage} />
    <Route path="account/offboarded_ent_email_verify/:token" getComponent={OffBoardingEmailVerificationPage} />
    <Route path="account/recovery_email_verify/:token" getComponent={RecoveryEmailVerificationPage} />

    <Route path="ssoCallback" getComponent={SSOCallback} />

    <Route path="auth/openai" getComponent={OpenAIAuthPage} />

    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
